import { get, post, put, deleteRequest } from "../../../../shared/data";
//import { searchReferences } from '../../../coding/lib/referenceData';

export const getReceivers = () => {
    return get("/receiving/receivers").then((data) => {
        return data.map((c) => {
            return { text: c.name, value: c.key };
        });
    });
};

export const getProducts = (shipmentKey) => {
    // {
    //     "upc": "string",
    //     "isDamaged": true,
    //     "notes": "string",
    //     "binTrackingNumber": "string",
    //     "generateUpc": true,
    //     "key": "string",
    //     "createdBy": "string",
    //     "createdOn": "2018-03-16T20:46:04.441Z",
    //     "updatedBy": "string",
    //     "updatedOn": "2018-03-16T20:46:04.441Z"
    //   }
    return get(`/receiving/shipments/${shipmentKey}/products`);
};

// **** Expected Payload
// {
//     "upc": "string",
//     "isDamaged": true,
//     "notes": "string",
//     "binTrackingNumber": "string",
//     "generateUpc": true,
//     "key": "string"
//   }
export const addProductToShipment = (shipmentKey, payload) => {
    return post(`/receiving/shipments/${shipmentKey}/products`, payload, { passthrough: true });
};

// **** Expected Payload
// {
//     "upc": "string",
//     "isDamaged": true,
//     "notes": "string",
//     "binTrackingNumber": "string",
//     "generateUpc": true,
//     "key": "string"
//   }
export const updateProduct = (shipmentKey, payload) => {
    return put(`/receiving/shipments/${shipmentKey}/products/${payload.key}`, payload, { passthrough: true });
};

export const deleteProduct = (shipmentKey, productKey) => {
    return deleteRequest(`/receiving/shipments/${shipmentKey}/products/${productKey}`);
};

export const getDuplicateProducts = (upc) => {
    return [];
    /*return searchReferences({upc}).then((references) => {
        return references.filter((ref) => ref.upc === upc);
    });*/
};

export const getPackageLevels = () => {
    return get("/receiving/packagelevels");
};

export const cvidLookup = (upc) => {
    return get(`/receiving/shipments/products/search/cvid?upc=${upc}`, { defaultReturn: [] });
};
